/**
 * Used for dispatching errors, such as validation errors.  See
 * actions/load_est.js for an example of how to use these.
 */
export const NO_ERROR = 'NO_ERROR'
export const EMPTY_FIELD_REQUIRED = 'EMPTY_FIELD_REQUIRED'
